module.exports = __webpack_public_path__ + "media/images/landing/bg/case-emco-44c3fd86e92809ec639c35e0add1ca22.jpg";